import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  desc?: string;
  action?: { label: string; to: string };
  align?: "left" | "center";
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  action,
  align = "left",
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 ${
        centered ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={centered ? "max-w-2xl" : "max-w-2xl"}>
        {kicker && (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <span className="h-3 w-3 rounded-full border border-primary-400" />
            {kicker}
          </span>
        )}
        <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 ${
            centered ? "" : "shrink-0"
          }`}
        >
          {action.label}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}